import { render, staticRenderFns } from "./customerScene.vue?vue&type=template&id=dcd88e3c&scoped=true&"
import script from "./customerScene.vue?vue&type=script&lang=js&"
export * from "./customerScene.vue?vue&type=script&lang=js&"
import style0 from "./customerScene.vue?vue&type=style&index=0&id=dcd88e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd88e3c",
  null
  
)

export default component.exports